// Safe post-login return (OAD-099).
//
// The intended destination is preserved as a `next` query parameter and validated before use.
// ONLY a same-application relative path is ever accepted: absolute URLs, protocol-relative URLs,
// foreign hosts, backslash tricks and malformed values are refused so a link can never bounce a
// signed-in member off Startup Otter. Invalid values fall back to normal post-login navigation.

export const sanitizeNext = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  let value = raw.trim();
  if (!value || value.length > 512) return null;
  try {
    value = decodeURIComponent(value);
  } catch {
    return null;
  }
  value = value.replace(/\\/g, "/");
  if (!value.startsWith("/")) return null;      // relative internal paths only
  if (value.startsWith("//")) return null;      // protocol-relative
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(value)) return null;
  if (/[\u0000-\u001f]/.test(value)) return null;
  if (/^\/(login|signup|logout)(\/|$|\?)/i.test(value)) return null;
  return value;
};

export const withNext = (path, next) => {
  const safe = sanitizeNext(next);
  return safe ? `${path}?next=${encodeURIComponent(safe)}` : path;
};

export const nextFromSearch = (search) => {
  try {
    return sanitizeNext(new URLSearchParams(search || "").get("next"));
  } catch {
    return null;
  }
};
